// Shared appearance helpers (accent + density), persisted to localStorage so the Layout
// sidebar and the Settings page stay in sync.

// [a1, a2, a3, name]. Technical Green is index 0 (the product default).
export const ACCENTS: [string, string, string, string][] = [
  ["#10b981", "#059669", "#34d399", "Technical Green"],
  ["#3b82f6", "#2563eb", "#60a5fa", "Electric Blue"],
  ["#f59e0b", "#d97706", "#fbbf24", "Forge Amber"],
  ["#22b8cf", "#0e9bb0", "#56d4e3", "Steel Cyan"],
  ["#8b5cf6", "#7c3aed", "#a78bfa", "Violet"],
];

export function applyAccent(idx: number): void {
  const [a1, a2, a3] = ACCENTS[idx] ?? ACCENTS[0];
  const r = document.documentElement;
  r.style.setProperty("--accent", a1);
  r.style.setProperty("--accent-2", a2);
  r.style.setProperty("--accent-3", a3);
}

export type Density = "compact" | "regular" | "comfy";
export function applyDensity(d: string): void {
  document.documentElement.setAttribute("data-density", d);
}
